import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as notificationsActions from 'actions/notificationsActions';
import LHX from 'utils/LHX';
import { isDomainIe } from 'utils/utils';

import './NotificationsLayout.scss';

/* istanbul ignore next */
const mapStateToProps = state => ({
  notifications: state.notifications,
});

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    notificationsActionsBound: bindActionCreators(notificationsActions, dispatch),
  };
}

export class NotificationsLayout extends Component {
  static propTypes = {
    notifications: PropTypes.object,
    notificationsActionsBound: PropTypes.object,
  }

  closeNotification = (event) => {
    const { notificationsActionsBound } = this.props;
    event.preventDefault();
    notificationsActionsBound.toggleNotification('');
  }

  messages = {
    BASKET_EXPIRED: (
      <em>
        We’re sorry but because there was no interaction for over 15 minutes we’ve had to restart this purchase. We do this to
        ensure we give you the best possible price at the time of booking.
      </em>
    ),
    NO_EXTRAS: (<em>No extras available for this booking.</em>),
    CONNECTION_ERROR: (
      <em>
        This holiday can only be booked over the phone at this time. To continue with this booking, or to check other offers in
        this hotel, please speak to one of our friendly team at our call centre using the numbers below and quote the reference
        number provided.
        <strong> Call {LHX.landlinePhone} to speak to one of our friendly advisers.</strong>
        {
          !isDomainIe() && (
            <span>
              {
                LHX.isPhoneEnabled ? (
                  <span> Calls to 0800 numbers are normally free of charge from landlines but charges may apply from mobile
                  phones; calls to 01 numbers from mobile phones are often included in your inclusive minutes.</span>
                ) : (
                  <span> Calls to 0844 numbers will be charged at 5p per minute from BT Landlines.</span>
                )
              }
            </span>
          )
        }
      </em>
    ),
  };

  render() {
    const { notifications } = this.props;
    const message = notifications && notifications.name && this.messages[notifications.name];

    return message ? (
      <div className="notifications-layout">
        <div className="notifications-layout__inner">
          <span>{message}</span>
          <a href="#" className="notifications-layout__close" onClick={this.closeNotification} title="Close" />
        </div>
      </div>
    ) : (
      <span />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsLayout);



/** WEBPACK FOOTER **
 ** ./src/layouts/NotificationsLayout/NotificationsLayout.jsx
 **/